<template>
  <vs-popup fullscreen :title="title" :active.sync="popupActiveLocal">
      <ag-grid-vue
          ref="popupDetails"
          :gridOptions="gridOptions"
          class="ag-theme-material w-100 my-4 ag-grid-table"
          :columnDefs="columnDefs"
          :defaultColDef="defaultColDef"
          :rowData="items"
          colResizeDefault="shift"
          :animateRows="true"
          :pagination="false"
          :suppressPaginationPanel="true"
          :enableRtl="$vs.rtl">
      </ag-grid-vue>
  </vs-popup>
</template>
<script>
import { AgGridVue } from "@ag-grid-community/vue"
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'

export default {
  props: {
      data: {
          type: Array,
          required: true
      },
      popupActive: {
          type: Boolean,
          required: true
      },
      title: {
          type: String,
          required: true
      }
  },
  data() {
      return {
          gridOptions: {
              alignedGrids: [],
              suppressHorizontalScroll: true,
          },
          defaultColDef: {
              sortable: true,
              editable: false,
              resizable: true,
              suppressMenu: true
          },
          columnDefs: [
              {
                headerName: 'ID',
                field: 'id',
                filter: true,
                width: 120,
                // hide: this.$acl.check('school')
              },
              // {
              //   headerName: 'Servicio',
              //   field: 'name_service',
              //   filter: true,
              // },
              {
                  headerName: "Estudiante",
                  field: "student_display_name",
                  width: 240,
                  filter: true,
                  cellClass: "cellMayusc",
              },
              {
                  headerName: "Acudiente",
                  field: "guardian_display_name",
                  width: 240,
                  filter: true,
                  cellClass: "cellMayusc",
              },
              {
                headerName: 'Cuota',
                field: 'expiration_date',
                filter: true,
              },
              {
                headerName: 'Fecha de vencimiento',
                field: 'due_date',
                filter: true,
              },
              {
                headerName: 'Monto',
                field: 'amount',
                filter: true,
                valueFormatter: params => this.$options.filters.currencySign(params.data.amount, '$ '),
              },
          ],
          // popupActiveLocal: JSON.parse(this.popupActive)
      }
  },
  components: {
      AgGridVue,
  },
  computed: {
      popupActiveLocal: {
          get() {
              return JSON.parse(this.popupActive)
          },
          set() {
              this.$emit('updatePopupActive')
          }
      },
      items() {
          return this.data
      }
  },
}
</script>
